module.exports = __webpack_public_path__ + "static/media/swipe-arrow.4a583e66.svg";